var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('top-header',{attrs:{"title":_vm.$t('user')}}),_c('v-progress-linear',{attrs:{"color":"accent","indeterminate":"","active":_vm.loading}}),_c('user-details-card',{ref:"userDetailsCard",attrs:{"user":_vm.user},on:{"signin":_vm.signin}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }